import Container from 'components/container/Container';
import TextField from 'components/TextField/TextField';
import { FC, FocusEvent } from 'react';
import SuggestionList from './SuggestionList';
import { ISearchableField } from './types';

const SearchableField: FC<ISearchableField> = ({ state, ...props }) => {
  const { setState } = props;
  const { showDropDown, suggestionOptions, isLoading } = state;
  const { reference, name, label, value, errorMsg, onChange, onSelect } = props;
  const { ctProps } = props;

  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    e.target.setAttribute('autocomplete', 'new-password');
    setState(prevState => ({
      ...prevState,
      showDropDown: true,
    }));
  };

  const shouldOpen =
    showDropDown &&
    suggestionOptions &&
    value?.length >= 3;

  return (
    <Container mt={ctProps?.mt} mb={ctProps?.mb} className={'searchable-field'}>
      <TextField
        inputRef={reference}
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        inputClass={shouldOpen ? 'searchable-field-results' : ''}
        onFocus={handleFocus}
        errorMsg={shouldOpen ? '' : errorMsg}
      />
      <SuggestionList
        value={value}
        name={name}
        setState={setState}
        state={state}
        onSelect={onSelect}
        shouldOpen={!!shouldOpen}
      />
    </Container>
  );
};

export default SearchableField;
